import { type RpOccurrence, rpOccurrenceProxy } from '../../rpOccurrenceProxy'
import { buildAxiosInstance } from '../../../../../../../shared/utils/apiUtils'
import { convertFromCentValue } from '../../../../../../../shared/utils/formattingUtils'

interface Response {
  data: {
    rpOccurrence: RpOccurrence
  }
  error: string | null
}
export async function executeRpOccurrenceRetrieve (id: string): Promise<void> {
  rpOccurrenceProxy.relatedTransactions = null
  rpOccurrenceProxy.apiCall.loading = true
  rpOccurrenceProxy.apiCall.error = null
  try {
    const response = await buildAxiosInstance().post<Response>('/api/rp_occurrences/retrieve', { rpOccurrenceId: String(id) })

    if (response.data.error) {
      rpOccurrenceProxy.apiCall.error = response.data.error
    }
    if (!response.data?.data?.rpOccurrence) {
      rpOccurrenceProxy.apiCall.error = 'Unable to retrieve record'
    } else {
      const rpOccurrence = response.data?.data?.rpOccurrence

      rpOccurrence.amountCents = convertFromCentValue(rpOccurrence.amountCents, rpOccurrence.amountCurrencyType)

      if (rpOccurrence.transactions) {
        rpOccurrence.transactions.forEach(txn => {
          txn.amountCents = convertFromCentValue(txn.amountCents, txn.amountCurrencyType)
          txn.remainingAmountCents = convertFromCentValue(txn.remainingAmountCents, txn.remainingAmountCurrencyType)
        })
      }

      rpOccurrenceProxy.rpOccurrence = rpOccurrence
    }
  } catch (e) {
    if (e instanceof Error) {
      rpOccurrenceProxy.apiCall.error = e.message
    }
  } finally {
    rpOccurrenceProxy.apiCall.loading = false
  }
}
